import { create } from 'zustand';

const getInitialTheme = () => {
    const stored = localStorage.getItem('monquiz_theme');
    if (stored === 'dark' || stored === 'light') return stored;
    // Respect OS preference
    if (window.matchMedia?.('(prefers-color-scheme: dark)').matches) return 'dark';
    return 'light';
};

const applyTheme = (theme) => {
    document.documentElement.classList.toggle('dark', theme === 'dark');
};

// Apply on load
const initialTheme = getInitialTheme();
applyTheme(initialTheme);

const useThemeStore = create((set) => ({
    theme: initialTheme,

    toggleTheme: () => {
        set((state) => {
            const next = state.theme === 'dark' ? 'light' : 'dark';
            localStorage.setItem('monquiz_theme', next);
            applyTheme(next);
            return { theme: next };
        });
    },
}));

export default useThemeStore;
